import { UPDATE_VEHICLEINFO, UPDATE_USER_INFO } from "./vuex/constants";
import store from "./vuex/index";
import env from "./utils/env";
import IngeekJSAPI from "@/assets/js/ingeek-jsapi/index";
import { getIngeekUserInfo } from "./apis";

// 获取app设备信息
function getAppInfo() {
  return new Promise<void>((resolve) => {
    IngeekJSAPI.getSystemInfo({}, (res: any) => {
      console.error(res, "获取app设备信息");
      if (res.code === 200) {
        const urlParams = new URLSearchParams(window.location.search);
        const deviceId = urlParams.get("deviceId");
        const source = urlParams.get("source");
        const appId = urlParams.get("appId");
        store.commit(
          "UPDATE_ENV",
          Object.assign({}, res.data, {
            deviceId,
            source,
            appId,
          })
        );
      }
      resolve();
    });
  });
}

// 获取当前车辆信息
function getCurrentVehicleInfo() {
  return new Promise<void>((resolve) => {
    IngeekJSAPI.getCurrentVehicleDetailInfo({}, (res: any) => {
      console.error(res, "获取当前车辆信息");
      if (res.code === 200) {
        store.commit(UPDATE_VEHICLEINFO, res.data || {});
      }
      resolve();
    });
  });
}
// 获取app设备信息
function getUserInfo() {
  return new Promise<void>((resolve) => {
    IngeekJSAPI.getUserInfo({}, (res: any) => {
      if (res.code === 200) {
        store.commit(UPDATE_USER_INFO, Object.assign({}, res.data || {}));
        getIngeekUserInfo().then((userInfo) => {
          store.commit(
            UPDATE_USER_INFO,
            Object.assign({}, res.data || {}, userInfo.data || {})
          );
        });
      }
      resolve();
    });
  });
}

async function intApp() {
  return new Promise<void>((resolve) => {
    if (env.isSVW) {
      window.webViewJavascriptBridge.callHandler(
        "getNavBarHeight",
        {},
        (err: any, data: any) => {
          store.commit(
            "UPDATE_ENV",
            Object.assign(store.state.env, data.height)
          );
          resolve(data);
        }
      );
      resolve();
    } else {
      try {
        if (window?.ingeekJSApi?.ready) {
          window.ingeekJSApi.ready(() => {
            getAppInfo()
              .then(getCurrentVehicleInfo)
              .then(getUserInfo)
              .then(resolve);
          });
        } else {
          getAppInfo()
            .then(getCurrentVehicleInfo)
            .then(getUserInfo)
            .then(resolve);
        }
      } catch (err) {
        console.log(err);
      }
    }
  });
}
export { intApp };
